export default function() {}



//////////////////
// WEBPACK FOOTER
// ./~/@swimlane/ngx-charts/~/d3-shape/src/noop.js
// module id = 105
// module chunks = 0